import { useMemo } from 'react';

import {
    AdditionalDefault,
    createStaticDataProvider,
    DataProvider,
    fromTree,
    ModelData,
    StaticDataFetcherItem,
    TreeCollection,
} from '@hh.ru/magritte-ui';

import { Region, selectRegions } from 'store/autoReducers';
import { useSelector } from 'store/utils';

const convertRegionsToModelData = (regions: Region[], isRootLevel = true): ModelData[] => {
    return regions.map((region) => {
        const items = region.areas ? convertRegionsToModelData(region.areas, false) : undefined;

        const result: ModelData = {
            id: region.id,
            text: region.name,
            items,
        };

        // Добавляем пункт "другое" для каждого родителя (кроме корневого уровня) для работы с исключениями
        if (!isRootLevel && items && items.length > 0) {
            const otherId = `${region.id}_other`;
            result.items = [
                ...items,
                {
                    id: otherId,
                    text: 'Другое',
                    items: undefined,
                },
            ];
        }

        return result;
    });
};

export const useData = (): {
    collection: TreeCollection<AdditionalDefault>;
    provider: DataProvider<StaticDataFetcherItem>;
} => {
    const regions = useSelector((state) => selectRegions(state));

    return useMemo(() => {
        const modelData = convertRegionsToModelData(regions);
        const collection = fromTree<AdditionalDefault>(modelData);

        return {
            collection,
            provider: createStaticDataProvider(
                collection.toList().map((item) => ({
                    value: item.id,
                    text: item.text,
                }))
            ),
        };
    }, [regions]);
};
